import { jsx as _jsx } from "react/jsx-runtime";
import styles from "./index.module.css";
import { useAutoSaveTitle } from "../lib/useAutoSaveTitle";
const EditorTitle = ({ documentId, title, onChange, readOnly = false, autoSaveEnabled = true, }) => {
    useAutoSaveTitle({ title, documentId, enabled: autoSaveEnabled });
    return (_jsx("input", { placeholder: "Title", className: styles.title, value: title, readOnly: readOnly, disabled: readOnly, onChange: (e) => onChange(e.target.value) }));
};
export default EditorTitle;
